import React from "react";

import { login } from "../../services/authenticationService";

import Button from "../../components/Button";

import {
  LogoWrapper,
  Title,
  StyledLogo,
  ContainerStyled,
  StyledGrid,
} from "./style";

export default function Login() {
  const onLogin = React.useCallback(() => {
    login();
  }, []);

  return (
    <ContainerStyled>
      <StyledGrid>
        <LogoWrapper>
          <StyledLogo />

          <Title variant="h2">
            <strong>Inteligent Feedstock Flow</strong>
          </Title>
        </LogoWrapper>

        <Button
          onClick={onLogin}
          label="Sign in"
          size="large"
          variant="contained"
          color="primary"
        />
      </StyledGrid>
    </ContainerStyled>
  );
}

